"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDetails = exports.removeAuthToken = exports.setAuthToken = exports.getAuthToken = exports.withAppName = exports.getAppName = exports.UPLOAD_BASE_URL = exports.API_BASE_URL = void 0;
// Configuration constants
exports.API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
exports.UPLOAD_BASE_URL = process.env.REACT_APP_UPLOAD_BASE_URL;
const DEFAULT_APP_NAME = 'template-builder';
const APP_NAME_STORAGE_KEY = 'app_name';
// Resolves the `app_name` to send with every API request.
// - On first load, the embedding app (e.g. file-management) passes app_name
//   as a query param; that value is captured and persisted to sessionStorage
//   so it survives client-side navigation within this SPA where the query
//   param itself may be dropped.
// - Falls back to whatever was previously persisted, then to the default.
const getAppName = () => {
    try {
        const fromQuery = new URLSearchParams(window.location.search).get('app_name');
        if (fromQuery) {
            sessionStorage.setItem(APP_NAME_STORAGE_KEY, fromQuery);
            return fromQuery;
        }
        const stored = sessionStorage.getItem(APP_NAME_STORAGE_KEY);
        if (stored)
            return stored;
    }
    catch (_a) {
        // sessionStorage/window can be unavailable (SSR, privacy mode) — fall through.
    }
    return DEFAULT_APP_NAME;
};
exports.getAppName = getAppName;
// Appends app_name to a request URL so the backend knows which embedding
// app (social, whatsapp, etc.) originated the call — without this, template
// listing/build APIs fall back to the wrong module context.
const withAppName = (endpoint) => {
    try {
        const url = new URL(endpoint, window.location.origin);
        if (!url.searchParams.has('app_name')) {
            url.searchParams.set('app_name', (0, exports.getAppName)());
        }
        return url.toString();
    }
    catch (_a) {
        return endpoint;
    }
};
exports.withAppName = withAppName;
// Helper function to get auth token from localStorage (pure React approach)
const getAuthToken = () => {
    var _a;
    const token = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith('crm-access-token='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    console.log(token);
    return token || null;
};
exports.getAuthToken = getAuthToken;
// Helper function to set auth token in localStorage
const setAuthToken = (token) => {
    localStorage.setItem('auth-token', token);
};
exports.setAuthToken = setAuthToken;
// Helper function to remove auth token from localStorage
const removeAuthToken = () => {
    localStorage.removeItem('auth-token');
};
exports.removeAuthToken = removeAuthToken;
// Helper function to get auth token from localStorage (pure React approach)
const getUserDetails = () => {
    var _a;
    const userDetails = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith('crm-user-detail='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    console.log(userDetails);
    return userDetails ? JSON.parse(decodeURIComponent(userDetails)) : {};
};
exports.getUserDetails = getUserDetails;
